import React from "react";
import Huynh from "./Huynh";
import Lone from "./Lone";
import Malas from "./Malas";
import Moe from "./Moe";
import Ray from "./Ray";
import Palak from "./Palak";

const Providers = () => {
  return (
    <div>
      <Huynh />
      <Lone />
      <Malas />
      <Ray />
      <Moe />
      <Palak />
    </div>
  );
};

export default Providers;
